import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'

import actions from '../../components/CurrentUserLoader/actions.js'
import conf from '../../../shared/conf.js'
import MyAgent from "./Containers/MyAgent/MyAgent.jsx"

class MyAgentContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, ...rest} = this.props
    if (!endLoadingCurrentUser || !currentFreelance) {
      return null
    }

    return (
      <StrategyFreelanceContainer
        currentUser={currentUser}
        isOwner={!!currentUser}
        loading={!endLoadingCurrentUser}
        navbar={true}
        user={currentUser}
        freelance={currentFreelance}
        view={MyAgent}
        {...rest}
      />
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(MyAgentContainer, conf.accountTypes.freelance))